module.exports = __webpack_public_path__ + "img/tabbed-search-filter-v-search-bar-luxury-cjdr.3c5fec5a.png";